export const versionConfig = {
  version: "1.0.17",
  buildDate: "2026-01-25",
  changelog: `
Users will no longer accidentally change number values while scrolling through forms

Add Export Feature for Stock Items with CSV and PDF Options

Add Vendor Shipping Lead Time Field to vendors

Add new UOM - Film

Add GTIN copy-to-clipboard feature to Stock Items List

PO:

  Fix vendor ETA column not populating in purchase orders list

  Add "Confirmed" status for the Purchase Orders list

  Add manufacturer field to distinguish between product manufacturer and supplier/vendor. Load stock items according to manufacturer

  PO list - The table now has three date columns that clearly show the purchase order timeline:

      1. Requested Delivery - Your desired/target delivery date
      2. Vendor ETA - When the vendor says items will arrive (earliest from all confirmations)
      3. Last Received - When items were actually last received into inventory

  Receive One PO Line as Multiple Batches
  When receiving inventory from a vendor confirmation, you can now split a single PO line item into multiple rows with different LOT numbers and Best Before dates

  BB Date and LOT are removed from the vendor confirmations table

Implement automated inventory warning system that calculates reorder alerts based on projected stock levels, considering current inventory, arriving shipments, daily usage trends, and vendor lead times

Change quantity-related fields from Integer to Decimal across the system

Add company_name and default_manufacturer fields to SystemSettings

Item Families for stock items

Recipes management
  `,
  showNotification: true,
  forceReset: true
}

// Backward compatibility exports
export const version = versionConfig.version
export const buildDate = versionConfig.buildDate
